import { HTMLAttributes } from 'react'

import Builder from '@/components/layout/Builder'
import HeroResize from '@/components/sections/HeroResize'
import Spacer from '@/components/sections/Spacer'
import TextOnImage from '@/components/sections/TextOnImage'
import { useStore } from '@/contexts/store'

import { WPPageData } from '@/types'

export type ProjectProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
  is_post: boolean
}

const Project = ({ pageData, is_post }: ProjectProps) => {
  const { strings } = useStore()
  return (
    <>
      <HeroResize
        pretitle={
          is_post ? strings?.newsroom_label : pageData?.acf.hero.headline
        }
        image={pageData?.acf?.hero?.poster?.desktop}
        image_desktop={pageData?.acf?.hero?.poster?.desktop}
        image_mobile={pageData?.acf?.hero?.poster?.mobile}
        title={pageData?.title.rendered}
      />
      <Builder pageData={pageData} />
      {pageData?.next_post ? (
        <>
          <TextOnImage
            image={pageData?.next_post.featured_image}
            pretitle={
              is_post
                ? strings?.newsroom_label
                : pageData?.next_post?.acf.hero.headline
            }
            title={pageData?.next_post?.title.rendered}
            link={{
              url: pageData?.next_post?.link,
              title: '',
              target: '_self'
            }}
            is_boxed={true}
            is_in_lightbox={false}
          />
          <Spacer variant="xs" theme="light" />
        </>
      ) : null}
    </>
  )
}

export default Project
